var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00023 5.91777C5.80552 5.91815 5.61682 5.85034 5.4669 5.7261L0.466895 1.55944C0.112512 1.26488 0.0640098 0.738819 0.358562 0.384437C0.653114 0.0300538 1.17918 -0.0184487 1.53356 0.276103L6.00023 4.00944L10.4669 0.409437C10.6391 0.269628 10.8598 0.204212 11.0804 0.227674C11.3009 0.251135 11.503 0.361537 11.6419 0.534437C11.7962 0.707653 11.8713 0.937334 11.8491 1.16824C11.827 1.39914 11.7096 1.61036 11.5252 1.7511L6.52523 5.7761C6.37099 5.8807 6.18615 5.93058 6.00023 5.91777Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.ceffb11056c79547ad097fe93959bff7.svg";
export { ForwardRef as ReactComponent };